import { PersistentStorageStrategyFactory } from './factories';
import { cookieStorageStrategy, localStorageStrategy, sessionStorageStrategy, } from './strategies';
var resolver = new PersistentStorageStrategyFactory();
resolver.register(localStorageStrategy);
resolver.register(sessionStorageStrategy);
resolver.register(cookieStorageStrategy('rbfep'));
export var storage = resolver.getStrategy().storageInstance();
